import { Box, Picture } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"

const ItemImage = ({ image, lazyload, linkClickData }) => (
  <Link data-lc={linkClickData} to={image.url}>
    <Box width="100%">
      <Picture
        alt=""
        lazyload={lazyload}
        srcSet={
          image.srcSet || [
            {
              media: "(max-width: 767px)",
              srcSet: `
            ${image.mobile} 1x,
            ${image.mobile_2x} 2x,
          `,
            },
            {
              media: "(min-width: 768px) and (max-width: 1023px)",
              srcSet: `
          ${image.tablet} 1x,
          ${image.tablet_2x} 2x,
        `,
            },
            {
              media: "(min-width: 1024px)",
              srcSet: `
          ${image.desktop} 1x,
          ${image.desktop_2x} 2x,
        `,
            },
          ]
        }
      />
    </Box>
  </Link>
)

ItemImage.propTypes = {
  image: PropTypes.object,
  lazyload: PropTypes.bool,
  linkClickData: PropTypes.string,
}

export default ItemImage
